import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { deleteRecipient } from '../../../../../redux/actions/recipient.actions';

import RecipientDetails from './RecipientDetails';
import RecipientProgressView from './RecipientProgressView';
import ReceivedDonationsView from './ReceivedDonationsView';

const EmptyView = props => {
    return (
        <div className="recipient-page">
            <div className="recipient-header" />
            <div className="intro ">
                <div className="intro-text">Start by selecting a recipient OR <span onClick={() => props.openModal()} className="link">Add Recipient</span></div>
            </div>
        </div>
    );
};

class RecipientPage extends Component {
    shouldComponentUpdate(nextProps) {
        return (nextProps.match.params.clientId !== this.props.match.params.clientId) ||
            (nextProps.recipientState.recipients !== this.props.recipientState.recipients) ||
            (nextProps.match.params.section !== this.props.match.params.section) ||
            (nextProps.match.params.progressId !== this.props.match.params.progressId) ||
            (nextProps.match.params.tab !== this.props.match.params.tab)
    }
    openModal = () => {
        const { recipientState: { recipientsById } } = this.props;
        const { clientId } = this.props.match.params;
        const recipient = recipientsById[clientId] || null;
        const event = new CustomEvent('open-add-recipient-modal', {
            detail: recipient || null
        });
        window.dispatchEvent(event);
    }
    openDeleteModal = () => {
        const { recipientState: { recipientsById } } = this.props;
        const { clientId } = this.props.match.params;
        const recipient = recipientsById[clientId];
        const { first_name, last_name, middle_name } = recipient;
        const event = new CustomEvent('open-delete-modal', {
            detail: {
                content: `Are you sure you want to delete recipient ${first_name} ${middle_name} ${last_name}?`,
                onDelete: () => {
                    this.props.deleteRecipient(clientId);
                }
            }
        });
        window.dispatchEvent(event);
    }

    render() {
        const { match: { params: {clientId }}, recipientState } = this.props;
        const recipient = recipientState.recipientsById[clientId];
        return recipient ? (
            <div className="recipient-page">
                <div className="recipient-header">
                    <div className="full-width-title">
                        {recipient.first_name} {recipient.middle_name} {recipient.last_name}
                    </div>
                    <div className="right-buttons">
                        <button type="button" className="pt-button pt-small pt-intent-primary pt-icon-edit" onClick={this.openModal}>Edit</button>
                        <button type="button" className="pt-button pt-small pt-intent-danger pt-icon-trash" onClick={this.openDeleteModal}>Delete</button>
                    </div>
                </div>
                <div className="recipient-content">
                    <RecipientDetails recipientId={clientId} recipientState={recipientState} />
                    <ReceivedDonationsView recipientState={recipientState} />
                    <RecipientProgressView recipientState={recipientState} />
                </div>
            </div>
        ): <EmptyView openModal={this.openModal} />;
    }
}

const mapStateToProps = (state) => ({
    recipientState: state.recipient
});

export default withRouter(connect(
    mapStateToProps,
    { deleteRecipient }
)(RecipientPage));


// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/recipient/RecipientPage.jsx